import { User } from '@sr/types';
import React, { useState } from 'react';
import {
  ArrowRightIcon,
  Box,
  Button,
  Input,
  NModal,
  Text,
  TrashIcon,
} from '../../ui';
import API from '../../utils/api';

const DeleteAccountModal = ({ user }: { user: User }) => (
  <NModal title="Delete Account" OpenButton={<OpenButton />}>
    <ModalContent user={user} />
  </NModal>
);

function ModalContent({
  user,
  closeModal,
}: {
  closeModal?: () => void;
  user: User;
}) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    API.user.delete({ password }).catch((error) => {
      console.log('error', error);
      if (error.code === 'auth/wrong-password') {
        setError('Invalid password. Please try again.');
      } else {
        setError(
          error.message ||
            'Unkown error. Please email hello@standardresume.co for assistance.'
        );
      }
    });
  }

  return (
    <Box id="gi-delete-account-modal">
      <Text mb={6}>
        Deleteing your account cannot be undone. It will delete all of your data
        from our servers and your web resumes will no longer be accessible.
      </Text>
      <form onSubmit={handleSubmit}>
        <Input
          type="password"
          placeholder="Your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoFocus
        />
        {error && <Text pt={2}>{error}</Text>}
        <Button
          sx={{ justifyContent: 'space-between' }}
          mt={5}
          backgroundColor="red"
          type="submit"
        >
          Delete Account
          <ArrowRightIcon color="white" />
        </Button>
      </form>
    </Box>
  );
}

function OpenButton({ onClick }: { onClick?: () => void }) {
  return (
    <Button
      variant="link"
      color="red"
      pl={0}
      onClick={onClick}
      id="gi-open-delete-account"
    >
      <TrashIcon color="red" mr={2} /> Delete Account
    </Button>
  );
}

export default DeleteAccountModal;
